// 오토태깅 버전. enqueue API 호출 시점에 읽혀 version으로 백엔드에 전달된다.
// "latest"면 현재(기본) 버전이라 필드를 보내지 않고, "v1"/"v2"는 과거 버전.
export type AutoTagVersion = "latest" | "v1" | "v2";

const AUTO_TAG_VERSION_LOCAL_STORAGE_KEY = "auto-tag-version";

let cachedVersion: AutoTagVersion | null = null;

const isAutoTagVersion = (value: string | null): value is AutoTagVersion =>
  value === "latest" || value === "v1" || value === "v2";

const readVersion = (): AutoTagVersion => {
  if (typeof localStorage === "undefined") return "latest";
  const stored = localStorage.getItem(AUTO_TAG_VERSION_LOCAL_STORAGE_KEY);
  return isAutoTagVersion(stored) ? stored : "latest";
};

if (typeof window !== "undefined") {
  window.addEventListener("storage", (event) => {
    if (event.key === AUTO_TAG_VERSION_LOCAL_STORAGE_KEY) {
      cachedVersion = null;
    }
  });
}

export const getAutoTagVersion = (): AutoTagVersion => {
  if (cachedVersion === null) {
    cachedVersion = readVersion();
  }
  return cachedVersion;
};

export const setAutoTagVersion = (version: AutoTagVersion): void => {
  if (typeof localStorage === "undefined") return;
  localStorage.setItem(AUTO_TAG_VERSION_LOCAL_STORAGE_KEY, version);
  cachedVersion = version;
};
